// @flow

import React from 'react';
import { FormattedMessage } from 'react-intl';
import {
  TableCell,
  TableRow,
  Typography,
} from '@fortress-technology-solutions/fortress-component-library/Atoms';
import {
  Table,
  TableBody,
  TableHead,
} from '@fortress-technology-solutions/fortress-component-library/Molecules';
import { TableContainer } from '@fortress-technology-solutions/fortress-component-library/Organisms';
import { formatDateDisplayUTC } from '@fortress-technology-solutions/fortress-component-library/utils/index';
import type { GrossRentChangeFloorPlanTableProps } from '../types';
import messages from '../messages';
import {
  HEADER_MESSAGE_KEYS,
  bodyCellSx,
  headCellSx,
  tableContainerSx,
  tableSx,
  transparentRowSx,
} from './constants';
import { formatCurrencyCell } from './hooks';
import { useGrossRentChangeFloorPlanTable } from './useManageTable';

const GrossRentChangeFloorPlanTable = ({
  floorPlans,
  effectiveDate,
}: GrossRentChangeFloorPlanTableProps) => {
  const { floorPlans: sortedFloorPlans } = useGrossRentChangeFloorPlanTable({
    floorPlans,
    effectiveDate,
  });

  return (
    <TableContainer sx={tableContainerSx}>
      <Table size="small" sx={tableSx}>
        <TableHead sx={{ backgroundColor: 'transparent' }}>
          <TableRow sx={transparentRowSx}>
            {HEADER_MESSAGE_KEYS.map((messageKey) => (
              <TableCell
                key={messageKey}
                variant="head"
                align="left"
                sx={headCellSx}
              >
                <Typography variant="labelLarge" component="span">
                  <FormattedMessage {...messages[messageKey]} />
                </Typography>
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {sortedFloorPlans.map((floorPlan) => (
            <TableRow key={floorPlan.floorPlanId} sx={transparentRowSx}>
              <TableCell variant="body" align="left" sx={bodyCellSx}>
                <Typography variant="bodySmall" component="span">
                  {floorPlan.floorPlanName}
                </Typography>
              </TableCell>
              <TableCell variant="body" align="left" sx={bodyCellSx}>
                <Typography variant="bodySmall" component="span">
                  {floorPlan.bedsBath}
                </Typography>
              </TableCell>
              <TableCell variant="body" align="left" sx={bodyCellSx}>
                <Typography variant="bodySmall" component="span">
                  {formatCurrencyCell(floorPlan.grossRent)}
                </Typography>
              </TableCell>
              <TableCell variant="body" align="left" sx={bodyCellSx}>
                <Typography variant="bodySmall" component="span">
                  {formatCurrencyCell(floorPlan.utilityAllowance)}
                </Typography>
              </TableCell>
              <TableCell variant="body" align="left" sx={bodyCellSx}>
                <Typography variant="bodySmall" component="span">
                  {formatDateDisplayUTC(floorPlan.createdAt, 'MM/DD/YYYY')}
                </Typography>
              </TableCell>
              <TableCell variant="body" align="left" sx={bodyCellSx}>
                <Typography variant="bodySmall" component="span">
                  {floorPlan.createdByName}
                </Typography>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default GrossRentChangeFloorPlanTable;
